import resume from '../assets/pdf/resume.pdf'
import pic from './pic.jpg'
export const headerData = {
    name: 'Muhammad Abubakar',
    title: "Software Engineer",
    desciption:"I am a Software Engineer with over 2 years of experience. My expertise is building modern, scalable web and mobile applications that help businesses grow. I also specialize in AI solutions, UI/UX design, and developing high-quality digital products with exceptional user experiences.",
    image: pic,
    resumePdf: resume
}
